import type { AdminSuretyBond } from "@portal/api/bond/admin";
import { getStatusTagByBondStatus } from "@portal/components/ui/StatusTag";
import { TruncatedLabel } from "@portal/components/ui/TruncatedLabel";
import { type ColumnWidthSource, useColumnWidth } from "@portal/hooks/useColumnWidth";
import type { FC } from "react";
import { formatDisplayTitle } from "../../../../utils";

export type AdminBondStickyPanelProps = {
	bond: AdminSuretyBond;
	column: ColumnWidthSource;
	/** Commercial surety off: this row is the only chrome, so keep the name and status. */
	alwaysShow?: boolean;
};

export const AdminBondStickyPanel: FC<AdminBondStickyPanelProps> = ({
	bond,
	column,
	alwaysShow = false,
}) => {
	const wideEnoughForTitle = useColumnWidth(
		column,
		(width) => width === undefined || width >= 1920,
	);
	const wideEnoughForStatus = useColumnWidth(
		column,
		(width) => width === undefined || width >= 640,
	);
	const showTitle = alwaysShow || wideEnoughForTitle;
	const showStatus = alwaysShow || wideEnoughForStatus;

	return (
		<div
			data-testid="admin-bond-sticky-panel"
			className="flex items-center gap-3 whitespace-nowrap"
		>
			{showTitle && (
				<TruncatedLabel
					label={`${formatDisplayTitle(bond.displayTitle)} · ${bond.principalName}`}
					className="max-w-[240px] text-[12px] font-[550] text-secondary"
				/>
			)}
			{showStatus && (
				<div data-testid="admin-bond-sticky-status">{getStatusTagByBondStatus(bond.status)}</div>
			)}
		</div>
	);
};
